var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 37,
    viewBox: "0 0 26 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8938 0H18.3699C17.9834 0 17.6127 0.153535 17.3394 0.426829C17.0661 0.700123 16.9126 1.07079 16.9126 1.45728V35.358C16.9126 35.7445 17.0661 36.1152 17.3394 36.3885C17.6127 36.6617 17.9834 36.8153 18.3699 36.8153H23.8938C24.2803 36.8153 24.6509 36.6617 24.9242 36.3885C25.1975 36.1152 25.3511 35.7445 25.3511 35.358V1.45728C25.3511 1.07079 25.1975 0.700123 24.9242 0.426829C24.6509 0.153535 24.2803 0 23.8938 0ZM22.4365 2.91457V33.9007H19.8272V2.91457H22.4365Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98117 0H1.45729C1.07079 0 0.700124 0.153535 0.42683 0.426829C0.153535 0.700123 0 1.07079 0 1.45728V35.358C0 35.7445 0.153535 36.1152 0.42683 36.3885C0.700124 36.6617 1.07079 36.8153 1.45729 36.8153H6.98117C7.36767 36.8153 7.73833 36.6617 8.01163 36.3885C8.28492 36.1152 8.43846 35.7445 8.43846 35.358V1.45728C8.43846 1.07079 8.28492 0.700123 8.01163 0.426829C7.73833 0.153535 7.36767 0 6.98117 0ZM5.52388 2.91457V33.9007H2.91457V2.91457H5.52388Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.fe11d6d118ee44ae3bc25fd12d041092.svg";
export { ForwardRef as ReactComponent };